'use client'

import React from 'react'

import { RadiusKeys } from '../../themes'
import { Image as SkeletonImage } from './Image'
import { Container } from './styles'

export type { ImageProps as SkeletonImageProps } from './Image'
export interface SkeletonProps {
  /**
   * Class name
   */
  className?: string

  /**
   * Show skeleton only when loading is set to `true`
   */
  loading?: boolean

  /**
   * Has image?
   */
  image?: boolean

  // /**
  //  * Has paragraph?
  //  */
  // paragraph?:
  //   | boolean
  //   | {
  //       rows?: number
  //     }

  /**
   * Button with full width
   */
  width?: number

  /**
   * Button with full width
   */
  height?: number

  /**
   * Corner radius
   */
  rounded?: RadiusKeys
}

type SkeletonComponent = React.FC<SkeletonProps> & {
  Image: typeof SkeletonImage
}

/**
 * Skeleton component
 */
export const Skeleton: SkeletonComponent = ({
  className,
  image,
  width,
  height,
  rounded,
  loading = true,
}: SkeletonProps) => {
  return loading ? (
    <Container className={className}>
      {image && (
        <SkeletonImage width={width} height={height} rounded={rounded} />
      )}
    </Container>
  ) : null
}

Skeleton.Image = SkeletonImage
